import React from 'react'

export interface Props {
  icon: JSX.Element
  label: JSX.Element
  active: boolean
  badgeText?: string
  onToggle: () => void
}

const MenuToggle = ({ label, icon, badgeText, active, onToggle }: Props) => {
  return (
    <div className={`actions__item ${active && 'active'}`}>
      <button onClick={onToggle} type="button" className="actions__btn" data-cy="menuToggle">
        {badgeText && <div className="actions__counter">{badgeText}</div>}
        {icon}
        <div>{label}</div>
      </button>
    </div>
  )
}

export default MenuToggle
